import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
const WideDashIcon = ({
  color = '#AFAFAF',
  width = '14',
  height = '2',
  className
}: IconProps) => <SvgIcon className={className} width={`${width}px`} height={`${height}px`} viewBox={`0 0 ${width} ${height}`} data-sentry-element="SvgIcon" data-sentry-component="WideDashIcon" data-sentry-source-file="WideDashIcon.tsx">
		<rect width={`${width}px`} height={`${height}px`} rx="1" fill={color} data-sentry-element="rect" data-sentry-source-file="WideDashIcon.tsx" />
	</SvgIcon>;
export default WideDashIcon;